import { FC } from "react";
import { useTranslation } from "react-i18next";

import { ComplianceStatus } from "../../services/certificateStatus";
import { formatDate } from "../../services/formatters";

interface CertificateStatusProps {
  coveredByParent?: boolean;
  validUntil?: number | string | null;
  status?: ComplianceStatus;
}

const CertificateStatus: FC<CertificateStatusProps> = ({ coveredByParent = false, validUntil, status }) => {
  const { t } = useTranslation();

  if (coveredByParent) {
    return null;
  }
  if (!status) {
    return <>{validUntil ? formatDate(validUntil) : t("certificate.never_expires")}</>;
  }
  if (status === "missing") {
    return <>{t("certificate.missing")}</>;
  }
  return <>{validUntil ? formatDate(validUntil) : t("certificate.never_expires")}</>;
};

export default CertificateStatus;
